import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/base/property/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
  request.get('/api/base/property/detail', Object.assign({}, options, { params }));

export const getRoomInfo = (params, options) =>
  request.get('/api/base/property/roomInfo', Object.assign({}, options, { params }));

export const getDetailById = (params, options) =>
  request.get('/api/base/property/detailById', Object.assign({}, options, { params }));

export const removeNode = (params, options) =>
  request.post('/api/base/property/removeNode', qs.stringify(params), options);

export const removeProperty = (params, options) =>
  request.post('/api/base/property/removeProperty', qs.stringify(params), options);

export const add = (params, options) => request.post('/api/base/property/submit', params, options);

export const update = (params, options) =>
  request.post('/api/base/property/submit', params, options);

export const getTrackTree = (params, options) =>
  request.get('/api/base/property/tree', Object.assign({}, options, { params }));

export const getTreeChildrenNode = (params, options) =>
  request.get('/api/base/property/treeChildrenNode', Object.assign({}, options, { params }));

//这个接口是新版的房产管理页面-左侧树使用,
export const getTreeChildrenNode2 = (params, options) =>
  request.get('/api/base/property/treeChildrenNode2', Object.assign({}, options, { params }));

export const addNode = (params, options) =>
  request.post('/api/base/property/nodeSubmit', params, options);

export const updateNode = (params, options) =>
  request.post('/api/base/property/nodeSubmit', params, options);

export const addProperty = (params, options) =>
  request.post('/api/base/property/propertySubmit', params, options);

export const updateProperty = (params, options) =>
  request.post('/api/base/property/propertySubmit', params, options);

export const getOptionNode = (params, options) =>
  request.get('/api/base/property/optionNode', Object.assign({}, options, { params }));

export const getTreeChildrenPowerNode = (params, options) =>
  request.get('/api/base/property/treeChildrenPowerNode', Object.assign({}, options, { params }));

export const treeChildrenPowerNodeCount = (params, options) =>
  request.get(
    '/api/base/property/treeChildrenPowerNodeCount',
    Object.assign({}, options, { params })
  );

//房产懒加载
export const lazyBasePropertyTree = (parentId) => {
  return request({
    url: '/api/base/property/lazyBasePropertyTree',
    method: 'get',
    params: {
      parentId,
    },
  });
};
export const getCommunityTree = (params, options) =>
  request.get('/api/base/property/getCommunityTree', Object.assign({}, options, { params }));

//只获取公寓小区
export const getDepartmentCommunityTree = (params, options) =>
  request.get(
    '/api/base/property/getDepartmentCommunityTree',
    Object.assign({}, options, { params })
  );
//获取字典
export const getDict = (code) => request.get('api/blade-system/dict/dictionary?code=' + code,);
//获取字典
export const getBusinessDict = (code) => request.get('api/blade-system/dict-biz/dictionary?code=' + code,);
//获取成员列表
export const getRoomMember = (params, options) => request.get('api/base/property/roomMember', Object.assign({}, options, { params }));
//获取使用性质
export const getUseTypes = () => request.get('api/base/property/getUseTypes?code=use_type&remark=1',);


